import { Modal, Icon } from 'semantic-ui-react';
import styled from '@emotion/styled';

const UnassignModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  position: relative;
`;
const Close = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  padding-right: 24px;
`;
const ActualContent = styled.div`
  padding: 0 35px;
  display: flex;
`;

const Information = styled.div`
  width: 390px;
  height: 48px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  margin-top: 8px;
  font-size: 16px;
  line-height: 24px;
  color: #4d4e4d;
`;

interface PropTypes {
  openState: boolean;
  onClose: (e?: any) => void;
  titleNumExistsOrderId: boolean;
}

const DuplicateTitleModal = (props: PropTypes) => {
  return (
    <Modal open={props.openState} style={{ height: 160, width: 440 }} onClose={props.onClose}>
      <UnassignModalContent>
        <Close onClick={props.onClose}>
          <Icon name="close" />
        </Close>
        <ActualContent>
          <Information>
            This file number already exists in our system.
            <br />
            To add a contin or update, click{' '}
            <a
              href={`/order/${props.titleNumExistsOrderId}`}
              target={'_blank'}
              rel="noreferrer"
              onClick={props.onClose}
            >
              {' '}
              here{' '}
            </a>{' '}
            to access the original file.
          </Information>
        </ActualContent>
      </UnassignModalContent>
    </Modal>
  );
};

export default DuplicateTitleModal;
